import * as AlertBarState from '../../components/alert-bar/AlertBar.state';
import * as Nested from '../../utils/Nested';
import { OrdersIndexFiltersForm } from './OrdersIndexFiltersForm';

// Default State
const initialState = {
  data: null,
  loading: false,
  isLoadingOrders: true,
  isLoadingFilters: false,
  shouldClear: false,
  currentPage: 1, // api uses page 1 as first page
  pageSize: 15,
  pageCount: 0,
  isSearchError: false,
  filters: [],
  batches: [],
  users: [],
};

// Action Creators and Action Types
export const FETCH_ORDERS_REQUEST = 'FETCH_ORDERS_REQUEST';
export const fetchOrdersRequest = (payload) => ({
  type: FETCH_ORDERS_REQUEST,
  payload,
});
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const fetchOrdersSuccess = (payload) => ({
  type: FETCH_ORDERS_SUCCESS,
  payload,
});
export const FETCH_ORDERS_ERROR = 'FETCH_ORDERS_ERROR';
export const fetchOrdersError = (payload) => ({
  type: FETCH_ORDERS_ERROR,
  payload,
});

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const fetchUsersRequest = (payload) => ({
  type: FETCH_USERS_REQUEST,
  payload: payload,
});
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const fetchUsersSuccess = (payload) => ({
  type: FETCH_USERS_SUCCESS,
  payload,
});
export const FETCH_USERS_ERROR = 'FETCH_USERS_ERROR';
export const fetchUsersError = (payload) => ({
  type: FETCH_USERS_ERROR,
  payload,
});

export const FETCH_BATCHES_REQUEST = 'FETCH_BATCHES_REQUEST';
export const fetchBatchesRequest = (payload) => ({
  type: FETCH_BATCHES_REQUEST,
  payload: payload,
});
export const FETCH_BATCHES_SUCCESS = 'FETCH_BATCHES_SUCCESS';
export const fetchBatchesSuccess = (payload) => ({
  type: FETCH_BATCHES_SUCCESS,
  payload,
});
export const FETCH_BATCHES_ERROR = 'FETCH_BATCHES_ERROR';
export const fetchBatchesError = (payload) => ({
  type: FETCH_BATCHES_ERROR,
  payload,
});

// Nested Actions
export const CLEAR_SEARCH_FORM_ACTION = 'search/CLEAR_SEARCH_FORM_ACTION';
export const clearSearchFormAction = Nested.nestedAction(
  CLEAR_SEARCH_FORM_ACTION,
);

export const SEARCH_ORDERS_ACTION = 'search/SEARCH_ORDERS_ACTION';
export const searchOrdersAction = Nested.nestedAction(SEARCH_ORDERS_ACTION);

// Form actions & types
export const ORDERS_INDEX_FILTERS_FORM_ACTION =
  'orderDetails/ORDERS_INDEX_FILTERS_FORM_ACTION';
export const ordersIndexFiltersFormAction = Nested.nestedAction(
  ORDERS_INDEX_FILTERS_FORM_ACTION,
);

// Alert Bar Nested Actions
export const ALERT_BAR_ACTION = 'ordersIndex/ALERT_BAR_ACTION';
export const ordersIndexAlertBarAction = Nested.nestedAction(ALERT_BAR_ACTION);

// Raw Reducer

export const _reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ORDERS_INDEX_FILTERS_FORM_ACTION:
      return {
        ...state,
        shouldClear: false,
      };
    case CLEAR_SEARCH_FORM_ACTION:
      return {
        ...state,
        shouldClear: true,
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: payload,
      };
    case FETCH_BATCHES_SUCCESS:
      return {
        ...state,
        batches: payload,
      };
    case FETCH_ORDERS_REQUEST:
      return {
        ...state,
        data: initialState.data,
        currentPage: payload.pageIndex,
        isLoadingOrders: true,
      };
    case FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        ...payload,
        isLoadingOrders: false,
      };
    case FETCH_USERS_REQUEST:
    case FETCH_BATCHES_REQUEST:
      return {
        ...state,
      };
    case FETCH_ORDERS_ERROR:
    case FETCH_USERS_ERROR:
    case FETCH_BATCHES_ERROR:
      return {
        ...state,
        fetching: false,
      };
    default:
      return state;
  }
};

// Raw Redux Maps
export const _mapStateToProps = (state) => ({
  ...state.ordersIndex,
});

export const _mapDispatchToProps = (dispatch) => ({
  fetchData: (data) => dispatch(fetchOrdersRequest(data)),
  clearSearchForm: () => dispatch(clearSearchFormAction()),
});

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    alertBars: {
      ordersIndexAlertBars: {
        ...AlertBarState,
        actionType: ALERT_BAR_ACTION,
      },
    },
    forms: {
      ordersIndexFiltersForm: {
        ...OrdersIndexFiltersForm,
        actionType: ORDERS_INDEX_FILTERS_FORM_ACTION,
      },
    },
  },
  'ordersIndex',
);

// Nested Reducer
const reducer = (state, action) => nestedReducer(state, action);
export { reducer, mapStateToProps, mapDispatchToProps, actions };
